<template>
    <section class="section" id="gallery">
        <div class="flex flex-wrap xl:items-center">
            <div class="container xl:w-45 xl:flex xl:flex-col xl:items-end">
                <div class="flex flex-wrap xl:justify-end xl:pr-lg">
                    <h2 class="section-title w-full md:w-3/5" v-scroll-reveal>
                        <span class="_order">02</span>
                        <span class="_title" v-html="$t('Gallery')"></span>
                    </h2>

                    <div class="w-full md:w-3/5">
                        <h3 class="section-subtitle" v-scroll-reveal v-html="$t('index.gallery.title')"></h3>
                    </div>
                </div>
            </div>

            <div class="w-full xl:w-55 xl:pl-base fhd:pl-lg">
                <video-item src="/video/momjan.mp4" class="mt-lg mb-lg md:mt-gap xl:my-0" v-scroll-reveal></video-item>
            </div>
        </div>

        <div class="gallery-box container container-wide xl:mt-lg">
            <div class="flex flex-wrap -mx-2 xl:-mx-base -mb-base xl:-mb-lg">
                <div class="_item-box _feat w-1/2 px-2 xl:px-base mb-base xl:mb-lg">
                    <figure class="_item" v-scroll-reveal style="background-image: url(/img/gallery/0-bazen.jpg)"></figure>
                </div>

                <div class="_item-box w-1/2 px-2 xl:px-base mb-base xl:mb-lg">
                    <figure class="_item" v-scroll-reveal style="background-image: url(/img/gallery/19-okolis.jpg)"></figure>
                </div>

                <div class="_item-box w-1/2 px-2 xl:px-base mb-base xl:mb-lg">
                    <figure class="_item" v-scroll-reveal style="background-image: url(/img/gallery/6-okolis.jpg)"></figure>
                </div>

                <div class="_item-box w-1/2 px-2 xl:px-base mb-base xl:mb-lg">
                    <figure class="_item" v-scroll-reveal style="background-image: url(/img/gallery/5-kuhinja.jpg)"></figure>
                </div>

                <div class="_item-box w-1/2 px-2 xl:px-base mb-base xl:mb-lg">
                    <figure class="_item" v-scroll-reveal style="background-image: url(/img/gallery/12-dnevna-soba.jpg)"></figure>
                </div>

                <div class="_item-box _feat w-1/2 px-2 xl:px-base mb-base xl:mb-lg">
                    <figure class="_item" v-scroll-reveal style="background-image: url(/img/gallery/20-terasa.jpg)"></figure>
                </div>

                <template>
                    <div class="_item-box _feat w-1/2 px-2 xl:px-base mb-base xl:mb-lg">
                        <figure class="_item" v-scroll-reveal style="background-image: url(/img/gallery/1-Soba-2.jpg)"></figure>
                    </div>
                    <div class="_item-box w-1/2 px-2 xl:px-base mb-base xl:mb-lg">
                        <figure class="_item" v-scroll-reveal style="background-image: url(/img/gallery/4-kupaona-1.jpg)"></figure>
                    </div>
                    <div class="_item-box w-1/2 px-2 xl:px-base mb-base xl:mb-lg">
                        <figure class="_item" v-scroll-reveal style="background-image: url(/img/gallery/8-Balkon.jpg)"></figure>
                    </div>
                    <div class="_item-box w-1/2 px-2 xl:px-base mb-base xl:mb-lg">
                        <figure class="_item" v-scroll-reveal style="background-image: url(/img/gallery/9-soba-1.jpg)"></figure>
                    </div>
                    <div class="_item-box w-1/2 px-2 xl:px-base mb-base xl:mb-lg">
                        <figure class="_item" v-scroll-reveal style="background-image: url(/img/gallery/15-kupaona-1.jpg)"></figure>
                    </div>
                    <div class="_item-box _feat w-1/2 px-2 xl:px-base mb-base xl:mb-lg">
                        <figure class="_item" v-scroll-reveal style="background-image: url(/img/gallery/18-kupaona-1.jpg)"></figure>
                    </div>
                    <div class="_item-box _feat w-1/2 px-2 xl:px-base mb-base xl:mb-lg">
                        <figure class="_item" v-scroll-reveal style="background-image: url(/img/gallery/1-soba-4.jpg)"></figure>
                    </div>
                    <div class="_item-box w-1/2 px-2 xl:px-base mb-base xl:mb-lg">
                        <figure class="_item" v-scroll-reveal style="background-image: url(/img/gallery/5-soba-3.jpg)"></figure>
                    </div>
                    <div class="_item-box w-1/2 px-2 xl:px-base mb-base xl:mb-lg">
                        <figure class="_item" v-scroll-reveal style="background-image: url(/img/gallery/8-kupaona-3.jpg)"></figure>
                    </div>
                    <div class="_item-box w-1/2 px-2 xl:px-base mb-base xl:mb-lg">
                        <figure class="_item" v-scroll-reveal style="background-image: url(/img/gallery/2-ljetna-kuhinja.jpg)"></figure>
                    </div>
                    <div class="_item-box w-1/2 px-2 xl:px-base mb-base xl:mb-lg">
                        <figure class="_item" v-scroll-reveal style="background-image: url(/img/gallery/11-ljetna-kuhinja.jpg)"></figure>
                    </div>
                    <div class="_item-box _feat w-1/2 px-2 xl:px-base mb-base xl:mb-lg">
                        <figure class="_item" v-scroll-reveal style="background-image: url(/img/gallery/12-ljetna-kuhinja.jpg)"></figure>
                    </div>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
export default {
}
</script>
